import { render, staticRenderFns } from "./SimpleEmailLink.vue?vue&type=template&id=02df9f16&scoped=true&"
import script from "./SimpleEmailLink.vue?vue&type=script&lang=js&"
export * from "./SimpleEmailLink.vue?vue&type=script&lang=js&"
import style0 from "./SimpleEmailLink.vue?vue&type=style&index=0&id=02df9f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02df9f16",
  null
  
)

export default component.exports